import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const footerLinks = [
    {
      title: '热门分类',
      links: categories.map((cat) => ({ label: cat.name, href: `/category/${cat.slug}` })),
    },
    {
      title: '快速导航',
      links: [
        { label: '首页', href: '/' },
        { label: '关于我们', href: '/about' },
        { label: '热门吃瓜', href: '/category/celebrity' },
        { label: '每日大赛', href: '/category/daily' },
      ],
    },
    {
      title: '热门标签',
      links: [
        { label: '顶流男星', href: '/category/celebrity' },
        { label: '网红翻车', href: '/category/influencer' },
        { label: '出轨实锤', href: '/category/social' },
        { label: '选秀黑幕', href: '/category/daily' },
      ],
    },
    {
      title: '联系我们',
      links: [
        { label: '投稿爆料', href: '/about' },
        { label: '商务合作', href: '/about' },
        { label: '侵权投诉', href: '/about' },
        { label: '用户协议', href: '/about' },
      ],
    },
  ];

  return (
    <footer className="bg-secondary-100 pt-14 pb-8 px-4 md:px-6">
      <div className="w-full max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-6 mb-12">
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                {group.title}
              </h4>
              <div className="w-8 h-px bg-primary-300 mb-4" />
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-xs text-foreground-600 hover:text-primary-600 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-secondary-200 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-center sm:text-left">
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-1">
              吃瓜爆料
            </h3>
            <div className="w-12 h-0.5 bg-primary-300 mb-2 mx-auto sm:mx-0" />
            <p className="text-xs text-foreground-500">
              全网热门吃瓜事件实时更新 · 做最懂吃瓜的社区
            </p>
          </div>

          <div className="flex items-center gap-4">
            <a
              href="#"
              rel="nofollow"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-200 text-foreground-600 hover:bg-primary-500 hover:text-white transition-colors"
              aria-label="站内动态"
            >
              <i className="ri-chat-1-fill text-sm" />
            </a>
            <a
              href="#"
              rel="nofollow"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-200 text-foreground-600 hover:bg-primary-500 hover:text-white transition-colors"
              aria-label="微信"
            >
              <i className="ri-wechat-fill text-sm" />
            </a>
            <a
              href="#"
              rel="nofollow"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-200 text-foreground-600 hover:bg-primary-500 hover:text-white transition-colors"
              aria-label="短讯"
            >
              <i className="ri-notification-3-fill text-sm" />
            </a>
          </div>
        </div>

        <div className="mt-6 text-center text-xs text-foreground-400">
          <p>吃瓜爆料 · 全网热门吃瓜事件实时更新 · 做最懂吃瓜的社区</p>
          <p className="mt-1">本站内容仅供娱乐参考，如有不实之处请联系删除</p>
        </div>
      </div>
    </footer>
  );
}
